
export default {
    name: 'NoteIcon',
    props: {
        strokeWidth: {
            type: Number,
            default: 2
        }
    }
}
